/* Display conversion only. Shopify product, cart and checkout amounts are unchanged. */
(function () {
  'use strict';
  function parseBase(text) {
    if (!text || !/\d/.test(text)) return null;
    var clean = text.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    return /^-?\d+(?:\.\d{1,2})?$/.test(clean) ? Math.round(Number(clean) * 100) : null;
  }
  function convert(cents, base, target, rates) {
    if (base === target) return cents / 100;
    if (!(rates[base] > 0) || !(rates[target] > 0)) return null;
    return cents / 100 * rates[base] / rates[target];
  }
  /* Country currency data derived from Unicode CLDR, retrieved 2026-10-21.
UNICODE LICENSE V3

COPYRIGHT AND PERMISSION NOTICE

Copyright © 1991-2026 Unicode, Inc.

NOTICE TO USER: Carefully read the following legal agreement. BY
DOWNLOADING, INSTALLING, COPYING OR OTHERWISE USING DATA FILES, AND/OR
SOFTWARE, YOU UNEQUIVOCALLY ACCEPT, AND AGREE TO BE BOUND BY, ALL OF THE
TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU DO NOT AGREE, DO NOT
DOWNLOAD, INSTALL, COPY, DISTRIBUTE OR USE THE DATA FILES OR SOFTWARE.

Permission is hereby granted, free of charge, to any person obtaining a
copy of data files and any associated documentation (the "Data Files") or
software and any associated documentation (the "Software") to deal in the
Data Files or Software without restriction, including without limitation
the rights to use, copy, modify, merge, publish, distribute, and/or sell
copies of the Data Files or Software, and to permit persons to whom the
Data Files or Software are furnished to do so, provided that either (a)
this copyright and permission notice appear with all copies of the Data
Files or Software, or (b) this copyright and permission notice appear in
associated Documentation.

THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
THIRD PARTY RIGHTS.

IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE DATA
FILES OR SOFTWARE.

Except as contained in this notice, the name of a copyright holder shall
not be used in advertising or otherwise to promote the sale, use or other
dealings in these Data Files or Software without prior written
authorization of the copyright holder.
  */
  var countryCurrencies = {"AC":["SHP"],"AD":["EUR"],"AE":["AED"],"AF":["AFN"],"AG":["XCD"],"AI":["XCD"],"AL":["ALL"],"AM":["AMD"],"AO":["AOA"],"AR":["ARS"],"AS":["USD"],"AT":["EUR"],"AU":["AUD"],"AW":["AWG"],"AX":["EUR"],"AZ":["AZN"],"BA":["BAM"],"BB":["BBD"],"BD":["BDT"],"BE":["EUR"],"BF":["XOF"],"BG":["EUR"],"BH":["BHD"],"BI":["BIF"],"BJ":["XOF"],"BL":["EUR"],"BM":["BMD"],"BN":["BND"],"BO":["BOB"],"BQ":["USD"],"BR":["BRL"],"BS":["BSD"],"BT":["BTN","INR"],"BV":["NOK"],"BW":["BWP"],"BY":["BYN"],"BZ":["BZD"],"CA":["CAD"],"CC":["AUD"],"CD":["CDF"],"CF":["XAF"],"CG":["XAF"],"CH":["CHF"],"CI":["XOF"],"CK":["NZD"],"CL":["CLP"],"CM":["XAF"],"CN":["CNY"],"CO":["COP"],"CR":["CRC"],"CU":["CUP"],"CV":["CVE"],"CW":["XCG"],"CX":["AUD"],"CY":["EUR"],"CZ":["CZK"],"DE":["EUR"],"DG":["USD"],"DJ":["DJF"],"DK":["DKK"],"DM":["XCD"],"DO":["DOP"],"DZ":["DZD"],"EA":["EUR"],"EC":["USD"],"EE":["EUR"],"EG":["EGP"],"EH":["MAD"],"ER":["ERN"],"ES":["EUR"],"ET":["ETB"],"EU":["EUR"],"FI":["EUR"],"FJ":["FJD"],"FK":["FKP"],"FM":["USD"],"FO":["DKK"],"FR":["EUR"],"GA":["XAF"],"GB":["GBP"],"GD":["XCD"],"GE":["GEL"],"GF":["EUR"],"GG":["GBP"],"GH":["GHS"],"GI":["GIP"],"GL":["DKK"],"GM":["GMD"],"GN":["GNF"],"GP":["EUR"],"GQ":["XAF"],"GR":["EUR"],"GS":["GBP"],"GT":["GTQ"],"GU":["USD"],"GW":["XOF"],"GY":["GYD"],"HK":["HKD"],"HM":["AUD"],"HN":["HNL"],"HR":["EUR"],"HT":["HTG","USD"],"HU":["HUF"],"IC":["EUR"],"ID":["IDR"],"IE":["EUR"],"IL":["ILS"],"IM":["GBP"],"IN":["INR"],"IO":["USD"],"IQ":["IQD"],"IR":["IRR"],"IS":["ISK"],"IT":["EUR"],"JE":["GBP"],"JM":["JMD"],"JO":["JOD"],"JP":["JPY"],"KE":["KES"],"KG":["KGS"],"KH":["KHR"],"KI":["AUD"],"KM":["KMF"],"KN":["XCD"],"KP":["KPW"],"KR":["KRW"],"KW":["KWD"],"KY":["KYD"],"KZ":["KZT"],"LA":["LAK"],"LB":["LBP"],"LC":["XCD"],"LI":["CHF"],"LK":["LKR"],"LR":["LRD"],"LS":["ZAR","LSL"],"LT":["EUR"],"LU":["EUR"],"LV":["EUR"],"LY":["LYD"],"MA":["MAD"],"MC":["EUR"],"MD":["MDL"],"ME":["EUR"],"MF":["EUR"],"MG":["MGA"],"MH":["USD"],"MK":["MKD"],"ML":["XOF"],"MM":["MMK"],"MN":["MNT"],"MO":["MOP"],"MP":["USD"],"MQ":["EUR"],"MR":["MRU"],"MS":["XCD"],"MT":["EUR"],"MU":["MUR"],"MV":["MVR"],"MW":["MWK"],"MX":["MXN"],"MY":["MYR"],"MZ":["MZN"],"NA":["NAD","ZAR"],"NC":["XPF"],"NE":["XOF"],"NF":["AUD"],"NG":["NGN"],"NI":["NIO"],"NL":["EUR"],"NO":["NOK"],"NP":["NPR"],"NR":["AUD"],"NU":["NZD"],"NZ":["NZD"],"OM":["OMR"],"PA":["PAB","USD"],"PE":["PEN"],"PF":["XPF"],"PG":["PGK"],"PH":["PHP"],"PK":["PKR"],"PL":["PLN"],"PM":["EUR"],"PN":["NZD"],"PR":["USD"],"PS":["ILS","JOD"],"PT":["EUR"],"PW":["USD"],"PY":["PYG"],"QA":["QAR"],"RE":["EUR"],"RO":["RON"],"RS":["RSD"],"RU":["RUB"],"RW":["RWF"],"SA":["SAR"],"SB":["SBD"],"SC":["SCR"],"SD":["SDG"],"SE":["SEK"],"SG":["SGD"],"SH":["SHP"],"SI":["EUR"],"SJ":["NOK"],"SK":["EUR"],"SL":["SLE"],"SM":["EUR"],"SN":["XOF"],"SO":["SOS"],"SR":["SRD"],"SS":["SSP"],"ST":["STN"],"SV":["USD"],"SX":["XCG"],"SY":["SYP"],"SZ":["SZL"],"TA":["GBP"],"TC":["USD"],"TD":["XAF"],"TF":["EUR"],"TG":["XOF"],"TH":["THB"],"TJ":["TJS"],"TK":["NZD"],"TL":["USD"],"TM":["TMT"],"TN":["TND"],"TO":["TOP"],"TR":["TRY"],"TT":["TTD"],"TV":["AUD"],"TW":["TWD"],"TZ":["TZS"],"UA":["UAH"],"UG":["UGX"],"UM":["USD"],"US":["USD"],"UY":["UYU"],"UZ":["UZS"],"VA":["EUR"],"VC":["XCD"],"VE":["VES"],"VG":["USD"],"VI":["USD"],"VN":["VND"],"VU":["VUV"],"WF":["XPF"],"WS":["WST"],"XK":["EUR"],"YE":["YER"],"YT":["EUR"],"ZA":["ZAR"],"ZM":["ZMW"],"ZW":["ZWG","USD"]};
  function detectedCountry(data) {
    var country = data && data.detected_values && data.detected_values.country;
    var code = country && country.handle;
    return typeof code === 'string' && /^[A-Z]{2}$/i.test(code) ? code.toUpperCase() : '';
  }
  function currencyForCountry(country, base, allowed) {
    var codes = countryCurrencies[country] || [];
    return codes.find(allowed) || base;
  }
  function createCurrencyPreference(options) {
    var version = 0;
    function save(code) {
      try {
        if (code) options.storage.setItem(options.key, code);
        else options.storage.removeItem(options.key);
      } catch (e) { /* The current page still works when browser storage is blocked. */ }
    }
    function automatic() {
      var request = ++version;
      options.render(options.base, true);
      return Promise.resolve().then(options.detectCountry).then(function (country) {
        if (request === version) options.render(currencyForCountry(country, options.base, options.allowed), true);
      }).catch(function () { /* Detection failure keeps the base currency. */ });
    }
    return {
      start: function () {
        var saved;
        try { saved = options.storage.getItem(options.key); } catch (e) { /* Use automatic selection without storage. */ }
        if (saved && options.allowed(saved)) {
          ++version;
          options.render(saved, false);
          return Promise.resolve();
        }
        return automatic();
      },
      select: function (code) {
        if (code === 'auto') {
          save(null);
          return automatic();
        }
        if (options.allowed(code)) {
          ++version;
          save(code);
          options.render(code, false);
        }
        return Promise.resolve();
      }
    };
  }
  // Pure helpers are exported only for local checks, never into the storefront global.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseBase: parseBase, convert: convert, detectedCountry: detectedCountry, currencyForCountry: currencyForCountry, createCurrencyPreference: createCurrencyPreference };
    return;
  }
  var config = document.getElementById('jl-currency-config');
  if (!config) return;
  var base = JSON.parse(config.textContent).base;
  var rates = window.Currency && window.Currency.rates || {};
  var selects = Array.from(document.querySelectorAll('[data-jl-currency-select]'));
  var currencyCodes = new Set(selects.flatMap(function (select) { return Array.from(select.options).map(function (option) { return option.value; }); }));
  var memory = new WeakMap();
  var selected = base;
  var storageKey = 'juicylens.displayCurrency';
  var formatter;
  function allowed(code) { return currencyCodes.has(code) && (code === base || Number.isFinite(rates[base]) && rates[base] > 0 && Number.isFinite(rates[code]) && rates[code] > 0); }
  function format(cents) {
    var amount = convert(cents, base, selected, rates);
    return amount === null ? null : formatter.format(amount) + ' ' + selected;
  }
  function updatePrices() {
    document.querySelectorAll('.money').forEach(function (node) {
      if (node.querySelector('.money')) return;
      var text = node.textContent.trim();
      var record = memory.get(node);
      if (!record || text !== record.last) {
        // Initial app attributes also allow a safe transition while uninstalling Beast.
        var raw = node.getAttribute('doubly-currency-' + base.toLowerCase());
        var cents = raw !== null && Number.isFinite(Number(raw)) ? Number(raw) : parseBase(text);
        if (cents === null || !Number.isFinite(cents)) return;
        record = { cents: cents, last: text };
        memory.set(node, record);
      }
      var result = format(record.cents);
      if (result !== null && text !== result) node.textContent = result;
      record.last = result === null ? text : result;
    });
  }
  function choose(code, automatic) {
    selected = allowed(code) ? code : base;
    formatter = new Intl.NumberFormat('en-US', { style:'currency', currency:selected });
    selects.forEach(function (select) {
      select.value = automatic ? 'auto' : selected;
      select.dataset.jlCurrency = selected;
      select.dataset.jlCurrencyMode = automatic ? 'auto' : 'manual';
      Array.from(select.options).forEach(function (option) {
        if (option.value === 'auto') option.label = automatic ? selected + ' · ' + option.dataset.jlAutoLabel : option.textContent;
        else option.label = !automatic && option.value === selected ? option.value : option.textContent;
      });
    });
    document.querySelectorAll('[data-jl-currency-note]').forEach(function (note) { note.hidden = selected === base; });
    updatePrices();
  }
  function requestCountry() {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 4000);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials:'same-origin', headers:{ Accept:'application/json' }, signal:controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    }).then(detectedCountry).finally(function () { clearTimeout(timeout); });
  }
  var storage;
  try { storage = window.localStorage; } catch (e) { /* Automatic selection still works without storage. */ }
  var preference = createCurrencyPreference({
    base:base, key:storageKey, storage:storage, allowed:allowed,
    render:choose, detectCountry:requestCountry
  });
  selects.forEach(function (select) {
    Array.from(select.options).forEach(function (option) { option.disabled = option.value !== 'auto' && !allowed(option.value); });
    select.disabled = false;
    select.addEventListener('change', function () {
      preference.select(select.value);
    });
  });
  preference.start();
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; updatePrices(); });
  }).observe(document.body, { subtree:true, childList:true, characterData:true });

  document.querySelectorAll('.jl-store-menu').forEach(function (menu) {
    menu.addEventListener('keydown', function (event) { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.jl-store-menu[open]').forEach(function (menu) { if (!menu.contains(event.target)) menu.open = false; });
  });
}());
